import React from "react";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import "./QueryErrorFallback.scss";

interface QueryErrorFallbackProps {
  error?: Error;
  resetError?: () => void;
  title?: string;
  description?: string;
  buttonText?: string;
}

export const QueryErrorFallback = ({
  error,
  resetError,
  title = "데이터를 불러올 수 없습니다",
  description,
  buttonText = "다시 시도",
}: QueryErrorFallbackProps) => {
  const { reset } = useQueryErrorResetBoundary();

  const handleRetry = () => {
    if (resetError) {
      resetError();
    } else {
      reset();
    }
  };

  const getErrorMessage = () => {
    if (description) return description;
    if (error?.message) return error.message;
    return "네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요.";
  };

  return (
    <div className="query-error-fallback">
      <div className="error-icon">
        <svg
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          className="w-16 h-16"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </div>
      <h2 className="error-title">{title}</h2>
      <p className="error-message">{getErrorMessage()}</p>
      <button className="retry-button" onClick={handleRetry}>
        {buttonText}
      </button>
    </div>
  );
};
